import user from '../../services/user.service';
import storage from '../../utils/storage';
export default {
    namespaced: true,
    state: {
        token: null,
        user: null,
    },
    getters: {
        authenticated(state) {
            return state.token && state.user;
        },
        getUser(state) {
            return state.user;
        },
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
        setUser(state, data) {
            state.user = data;
        },
    },
    actions: {
        SET_USER({ commit }, { payload, successCallback, errorCallback }) {
            user.userLogin({
                payload,
                success: ({ data }) => {
                    if (data.status === 'OK') {
                        let temp = {
                            userId: data.data.id,
                            imageUrl: data.data.profileImg,
                            name: data.data.name,
                            role: data.data.role,
                        };
                        commit('setUser', temp);
                        storage.setToken(temp);
                        successCallback && successCallback(data);
                    } else {
                        errorCallback && errorCallback(data);
                    }
                },
                error: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
    },
};
